<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '20',
	},
	height: {
		type: String,
		default: '20',
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
	<svg
		:width="width"
		:height="height"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 17"
		fill="none"
	>
		<path
			d="M8.00016 3.83301V13.1663M3.3335 8.49967H12.6668"
			:stroke="iconColor"
			stroke-width="1.33333"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
